import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { ProcedureTypesViewTopBar } from "./TopBar"

export const procedureTypesViewLayoutHandle: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: ProcedureTypesViewTopBar,
}
